module.exports = __webpack_public_path__ + "static/media/polina.874d8be6.png";